import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { EventTicket }                                  from 'Domain/Models';

export const getEventTickets = (state: TRootState, filter: null | IFilterProps<EventTicket> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<EventTicket>;
  }

  return filterObjectStore(state.eventTicket.entries, filter);
};
